import AutomatedTextSetter from './AutomatedTextSetter';

export default AutomatedTextSetter;
